import request from '@/api/utils';

export function setCompanyCreate(formdata = {}, method = 'post') {
  const url = '/api/company/create';
  return request.Api(url, formdata, method);
}

export function setCompanyEdit(formdata = {}, method = 'post') {
  const url = '/api/company/edit';
  return request.Api(url, formdata, method);
}

export function getCompanyList(formdata = {}, method = 'post') {
  const url = '/api/company/list';
  return request.Api(url, formdata, method);
}

export function getCompanyList1(formdata = {}, method = 'post') {
  const url = '/api/company/list1';
  return request.Api(url, formdata, method);
}

export function getCompany(formdata = {}, method = 'post') {
  const url = '/api/company/getCompany';
  return request.Api(url, formdata, method);
}
export function getCompanyDel(formdata = {}, method = 'post') {
  const url = '/api/company/delete';
  return request.Api(url, formdata, method);
}

export function getAdminCompany(formdata = {}, method = 'post') {
  const url = '/api/company/getAdminCompany';
  return request.Api(url, formdata, method);
}
export function setAdminCompanyLogo(formdata = {}, method = 'post') {
  const url = '/api/company/setCompanyLogo';
  return request.Api(url, formdata, method);
}
